module.exports = __webpack_public_path__ + "static/media/western-2.9bdff3c9.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/components/images/western-2.jpg
// module id = 117
// module chunks = 0